import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Carousel from "react-bootstrap/Carousel";
import KozmetikHomeItems from '../components/Home/KozmetikHomeItems';

import '../styles/home.css'

const Home = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    return (
        <div className='home-page'>
            <div className='logo-container'></div>
            <div>
                <Carousel variant="white" className="container-carousel2" fade>
                    <Carousel.Item interval={2500}>
                        <div className="d-block1">
                        </div>
                        <Carousel.Caption className="carosuel-content"></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item interval={2500}>
                        <div className="d-block2">
                        </div>
                        <Carousel.Caption className="carosuel-content"></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item interval={2500}>
                        <div className="d-block3">
                        </div>
                        <Carousel.Caption className="carosuel-content"></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item interval={2500}>
                        <div className="d-block4">
                        </div>
                        <Carousel.Caption className="carosuel-content"></Carousel.Caption>
                    </Carousel.Item>

                </Carousel>
            </div>
            <div className='exec-summary'>
                <Container>
                    <Row>
                        <div className='definition-title'>
                            Dermatoloji ve Estetik Kliniği
                        </div>
                    </Row>

                </Container>
            </div>
            <div className='definition-text'>
                KOZMETİK UYGULAMALAR
            </div>

            <div className='sub-items'>
                <KozmetikHomeItems />
            </div>

            <div className='definition-text'>
                Cildinizin sağlığı, genel sağlığınızla doğrudan ilişkilidir. Yılların verdiği tecrübe ile size özel çözümler sunmak için burada. Cilt hastalıkları, akne tedavisi, yaşlanma belirtileri ve cilt bakımı gibi birçok konuda profesyonel destek alabilirsiniz. Klinik olarak, her hastamızın ihtiyaçlarına uygun bireysel tedavi planları oluşturuyoruz.

                Sağlıklı, canlı ve genç bir cilt için doğru adres burası. Her sorunuzda yanınızdayız!
            </div>

        </div>
    )
}

export default Home